<template>
  <div>
    <v-grid theme="material" :source="data_table" :columns="columns" resize="true"
            :columnTypes='columnTypes' row-headers="true" frameSize="45"/>
  </div>

</template>

<script>

import VGrid from '@revolist/vue-datagrid';
import Plugin from "@revolist/revogrid-column-date";

export default {
  name: "revogrid-table",
  data: () => {
    return {
      columnTypes: {date: new Plugin()},
      columns: [
        {
          prop: "Id",
          name: "Индекс",
          size: 40,
        }, {
          prop: "date",
          name: "Дата",
          size: 200,
          columnType: 'date',
          columnTemplate: (createElement, column) => {
            return createElement('span', {
              style: {
                color: 'red',
                textAlign: 'center',
              },
            }, column.name);
          },
        },
        {
          prop: "city",
          name: "Город",
          size: 200,
        },
        {
          prop: "phone",
          name: "Телефон",
          size: 150,

        },
        {
          prop: "partner_id",
          name: "Партнер",
          size: 150,
        }, {
          prop: "source",
          name: "Источник",
          autoSize: true
        },
        {
          prop: "info",
          name: "Информация",
          autoSize: true
        },

      ]
    }
  },
  props: {
    data_table: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  components: {VGrid},
}
</script>

<style scoped>
div {
  height: 100vh;
  width: 100%;
}

revo-grid {
  height: 100%;
}

revogr-viewport-scroll .inner-content-table {
  height: 100%;
}

/* safari */
revogr-viewport-scroll .vertical-inner {
  display: flex;
  flex-direction: column;
}

revogr-viewport-scroll .content-wrapper {
  min-height: 100%;
  flex-grow: 1;
}

revogr-overlay-selection {
  display: block;
}

</style>
